
/* styles */
require("!!./../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-951970ca&scoped=true!./../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ManageCategories.vue")

var Component = require("!./../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ManageCategories.vue"),
  /* template */
  require("!!./../../../node_modules/vue-loader/lib/template-compiler?id=data-v-951970ca!./../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ManageCategories.vue"),
  /* scopeId */
  "data-v-951970ca",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/admin/ManageCategories.vue
// module id = 468
// module chunks = 1